const ERROR_MAP = {
  "service-is-no-longer-available": "Service is no longer available.",
  "Authentication Failed Please Re-enter Information":
    "Username and/or password were incorrect. Please update and try again.",
  "Card Expired": "Credit Card is Expired",
  "Username required": "Username is required.",
  "The link for this page is no longer valid": "The link for this page is no longer valid.",
  "Invalid Code": "Invalid Code",
  "Invalid SSL certificate": "Invalid SSL certificate",
  "Invalid SSL certificate and/or key": "Invalid SSL certificate and/or key",
  "Invalid application": "Invalid application",
  "You have reached your limit of sites on this plan. To add more sites, upgrade your plan.":
    "You have reached your limit of sites on this plan. To add more sites, upgrade your plan.",
  "You have reached your limit of sites on this plan To add more sites, upgrade your plan":
    "You have reached your limit of sites on this plan To add more sites, upgrade your plan",
  "Not Found": "Not Found",
  "Invalid Mysql Database Name or Username": "Invalid MySQL Database Name or Username",
  "E00027: This transaction has been declined.": "This transaction has been declined.",
  "email: User Exists": "Email already in use.",
  "CAPTCHA incorrect Please Retry": "TURNSTILE Failed Please Re-enter Information",
  "Invalid e-mail address": "Invalid Email",
  "E-mail exists": "Email already in use.",
  "Please Enter a Valid Value: How would you rate your experience with Nexcess on a scale of 1 to 10 with 10 being the most positive?":
    "Please Enter a Valid Value: How would you rate your experience with Nexcess on a scale of 1 to 10 with 10 being the most positive?",
  "The code you&#39;ve linked to is either invalid, expired, or has already been used":
    "The code you've linked to is either invalid, expired, or has already been used.",
  "Your primary credit card is currently expired!":
    "Your primary credit card is currently expired!",
  "Invalid credit card number": "Invalid credit card number",
  "Duplicate entry": "Duplicate entry",
  "Invalid IPv6 address": "Invalid IPv6 address",
  "Domain provided is already in use": "The provided domain is already in use.",
  "This card is expired or expires soon; it cannot be made your primary card":
    "This card is expired or expires soon. It can't be set set your primary card.",
  "Credit Card Error: This transaction has been declined.":
    "Credit Card Error: This transaction has been declined.",
  "This looks like a duplicate card If you need to make a change, edit or delete the other entry":
    "This looks like a duplicate card. If you need to make a change, edit or delete the other entry.",
  "Invalid FTP username": "Invalid FTP username",
  "Failed to add FTP user": "Failed to add FTP user",
  "You have reached the limit of credit cards you can add in a 24 hour period":
    "You have reached the limit of credit cards you can add in a 24 hour period",
  "Invalid Hostname: hostname": "Invalid Hostname: hostname",
  "This password is too weak":
    "Password not accepted. Please try a different one. Ensure your password isn’t a dictionary word, and doesn’t contain repetitive characters, or words that relate to your account, like “Nexcess”.",
  "Email alias already exists": "Email alias already exists",
  "The base account cannot fit on the chosen dev account":
    "Selected development environment’s disk space limit is insufficient for site’s current disk usage.",
  "domain: You are not allowed to add or edit this type of TLD Please contact support for assistance":
    "You are not allowed to add or edit this type of TLD. Please contact support for assistance.",
  LG_INVALID_ZIP: "Invalid Postal Code",
  "Invalid Location": "Server location not available. Please select another.",
};

const escape = (message) => message.replace(/[.]/g, "").replace(/[']/g, "&#39;");

const getOrReplace = (responseData) => {
  const translation = ERROR_MAP[`server.${escape(responseData)}`];
  return translation ? translation : responseData.replace("server.", responseData);
};

// TODO: clean up how we parse dynamic errors
const fromServer = (responseData, data) => {
  if (!responseData) return;
  // TODO: Review this conversion
  if (responseData === Object(responseData) && !Array.isArray(responseData)) {
    responseData = Object.values(responseData);
  } else {
    try {
      responseData = Object.values(JSON.parse(responseData));
    } catch (e) {
      // ignore
    }
  }

  if (Array.isArray(responseData)) {
    return responseData.map((resp) => getOrReplace(resp, data));
  }

  return [getOrReplace(responseData, data)];
};

export { fromServer };
